// firebase
import { db } from "config/firebase";
import { collection, getDocs } from "firebase/firestore";

// A ---------------------------------------------------------------------- M

const getTags = async () => {
  try {
    const snapshot = await getDocs(collection(db, "tagsdata"));
    const tagIds = snapshot.docs.map((doc) => doc.id);
    return tagIds;
  } catch (error) {
    console.error("Error in getTags:", error);
    return [];
  }
};

export default getTags;
